/**
 * WHAT BOTH VIEWS OF A VISIT DRAW: its facts, and the one big button to its job sheet. The
 * cleaner's view and the office's view both use them, so they live here rather than in either.
 */
import { Link } from 'react-router-dom';
import { VISIT_ORIGIN_LABELS } from '@fk/shared';
import type { VisitRow } from '../../api.ts';
import { Detail } from '../../components/AppShell.tsx';
import { formatInstant, formatWindow, longDay } from '../../format.ts';

/**
 * The facts of the visit itself. The kind is not among them: it is already a pill beside the
 * status at the top of both views, and a fact drawn twice reads as two facts.
 */
export function VisitFacts({ visit }: { visit: VisitRow }) {
  return (
    <>
      <Detail label="Day" value={longDay(visit.scheduledDate)} />
      <Detail
        label="Arrival window"
        value={formatWindow(visit.windowStart, visit.windowEnd) ?? 'Not set'}
      />
      <Detail label="Where the row came from" value={VISIT_ORIGIN_LABELS[visit.origin]} />
      <Detail label="Started" value={formatInstant(visit.startedAt)} />
      <Detail label="Finished" value={formatInstant(visit.finishedAt)} />
    </>
  );
}

/**
 * The one big button. The sheet is the address, the do-not list, how to get in, and the codes.
 * Big in a hand at a door; at a desk it is the primary button's size, 40px (ops #56).
 */
export function SheetButton({ visitId }: { visitId: string }) {
  return (
    <Link
      to={`/visits/${visitId}/sheet`}
      className="mb-4 inline-flex min-h-14 w-full items-center justify-center rounded-lg border border-navy bg-navy px-5 text-lg font-semibold text-cream desk:min-h-10 desk:text-base"
    >
      Open the job sheet
    </Link>
  );
}
